// src/utils/analytics.js

let initialized = false;

/**
 * Inicializira Google Consent Mode (privzeto zavrnjeno)
 */
export function initGoogleConsentMode() {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };

  // PRIVZETO: vse zavrnjeno
  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
}

/**
 * Naloži GA4 skripto
 * @param {string} measurementId - tvoj GA4 Measurement ID (npr. G-ZHGF9F3E95)
 */
export function initGA(measurementId) {
  if (initialized || !measurementId) return;

  // dodamo skripto
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=G-ZHGF9F3E95`;
  document.head.appendChild(script);

  // inicializiramo gtag
  window.gtag("js", new Date());
  window.gtag("config", measurementId, {
    anonymize_ip: true, // GDPR friendly
  });

  initialized = true;
}

/**
 * Dodeli soglasje za analitiko (ko uporabnik klikne "Sprejmi analitične")
 */
export function grantAnalyticsConsent() {
  if (!window.gtag) return;

  window.gtag("consent", "update", {
    analytics_storage: "granted",
  });
}